import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  useDisclosure
} from '@chakra-ui/react'
import {
  DialogBody,
  DialogContainer,
  DialogHeader
} from '@handlers/sessions/components/dialog'
import React from 'react'
import { Link } from 'react-router-dom'

interface CreateTemplateDialogProps {
  isOpen: boolean
  onClose: () => void
}

const FileIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.8334 26.6667H27.1667V30H13.8334V26.6667ZM13.8334 20H27.1667V23.3334H13.8334V20ZM23.8334 3.33337H10.5001C8.66675 3.33337 7.16675 4.83337 7.16675 6.66671V33.3334C7.16675 35.1667 8.65008 36.6667 10.4834 36.6667H30.5001C32.3334 36.6667 33.8334 35.1667 33.8334 33.3334V13.3334L23.8334 3.33337ZM30.5001 33.3334H10.5001V6.66671H22.1667V15H30.5001V33.3334Z"
      fill="#282828"
    />
  </svg>
)

const PlusIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.1666 21.6667H22.1666V31.6667H18.8333V21.6667H8.83325V18.3334H18.8333V8.33337H22.1666V18.3334H32.1666V21.6667Z"
      fill="#282828"
    />
  </svg>
)

export const CreateTemplateDialog = ({
  isOpen,
  onClose
}: CreateTemplateDialogProps) => {
  return (
    <DialogContainer isOpen={isOpen} onClose={onClose}>
      <DialogHeader text="Create Template" onClose={onClose} />
      <DialogBody>
        <Flex direction="row" gap="16px">
          <Box
            flex="1"
            border="1px solid"
            borderColor="pale_gray"
            borderRadius="8px"
            p="16px"
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="16px"
          >
            <FileIcon />
            <Heading as="h3" size="md" textAlign="center">
              Upload a sample
            </Heading>
            <Text h="60px" fontSize="12px" textAlign="center" color="dark_gray">
              Upload a sample note and we'll convert it into a template in
              seconds.
            </Text>
            <Button
              isFullWidth
              m="0px"
              variant="outline"
              bg="rgba(246, 247, 254, 1)"
              border="none"
            >
              <Text color="primary">Coming soon</Text>
            </Button>
          </Box>
          <Box
            flex="1"
            border="1px solid"
            borderColor="pale_gray"
            borderRadius="8px"
            p="16px"
            display="flex"
            flexDirection="column"
            alignItems="center"
            gap="16px"
          >
            <PlusIcon />
            <Heading as="h3" size="md" textAlign="center">
              Start from scratch
            </Heading>
            <Text h="60px" fontSize="12px" textAlign="center" color="dark_gray">
              Create a note template from scratch using our template builder.
            </Text>
            <Button
              isFullWidth
              m="0px"
              colorScheme="primary"
              as={Link}
              to="/settings/templates/new"
              onClick={onClose}
            >
              Use Builder
            </Button>
          </Box>
        </Flex>
      </DialogBody>
    </DialogContainer>
  )
}

export default CreateTemplateDialog
